// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"379":"73bb5b2b","429":"d67ec913","520":"85332067","722":"49fe6d2d","928":"16032d6c","982":"ab16027a"}[chunkId] + ".css";
};